

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {DateHelper} from "@/helpers/DateHelper";

  @Component({
    name: 'Datim',
  })
  export default class Datim extends Vue {

    @Prop()
    protected value!: string;
    // NOTE this param must be called 'short' but in practise its value works as it would be a notShort property
    @Prop({default: true})
    protected short!: boolean;
    @Prop({default: null})
    protected timezone!: string | null;

    protected longDate(s: string) {
      if (this.timezone) {
        return DateHelper.longDateTimeFormatTz(s, this.timezone);
      }
      return DateHelper.longDateTimeFormat(s);
    }

    protected shortDate(s: string) {
      if (this.timezone) {
        return DateHelper.dateFormatTz(s, this.timezone);
      }
      return !this.short
        ? DateHelper.shortDateFormat(s)
        : DateHelper.dateFormat(s);
    }

    protected timezoneLabel(s: string): string {
      if (!this.timezone) return '';
      const time = DateHelper.timeFormatTz(s, this.timezone);
      return this.timezone === 'Europe/London' ? time + ' · UK' : time;
    }

  }

